<template>
   <i :class="'iconfont '+name"> <slot></slot> </i>
</template>
<script>
export default {
    props:{
        name:{
            type:String,
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/icon.vue